import React from 'react';
import styled from 'styled-components';
import { PageSlice, SliceBenefitsTable, SliceBenefitsTableItem } from '@contracts';

interface Props {
  slice: PageSlice;
}

const BenefitsTable: React.FC<Props> = ({ slice }) => {
  const sliceDetails = slice.primary as SliceBenefitsTable;
  const sliceItems = slice.items as SliceBenefitsTableItem[];

  return (
    <BenefitsTableContainer>
      <Wrapper>
        <h2>{sliceDetails.heading.text}</h2>
        <BenefitsTableGrid>
          {sliceItems.map((item: any, index: number) => (
            <div key={index}>
              {item.image && item.image.url && <img src={item.image.url} alt={item.image.alt} />}
              {item.descriptions && <p>{item.descriptions}</p>}
            </div>
          ))}
        </BenefitsTableGrid>
      </Wrapper>
    </BenefitsTableContainer>
  );
};

export default BenefitsTable;

const BenefitsTableContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #fdf3de;

  & h2 {
    font-family: 'Domaine';
    font-size: 3rem;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -1.28px;
    text-align: center;
    padding: 0 4rem;
    margin: 0;

    @media (max-width: 600px) {
      font-size: 2rem;
      padding: 0 1rem 2rem;
    }
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 5rem 0 10rem 0rem;
`;

const BenefitsTableGrid = styled.div`
  display: grid;
  grid-template-rows: 2fr;
  grid-auto-rows: 1fr;
  grid-template-columns: 2fr 1fr 1fr 1fr;

  & p {
    font-size: 0.8rem;
  }

  & img {
    max-height: 50px;
  }

  & > div {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1rem;
    border-left: 1px solid #eba920;
    border-bottom: 1px solid #eba920;
  }

  /* remove border from first row */
  & > div:nth-of-type(1),
  & > div:nth-of-type(2),
  & > div:nth-of-type(3),
  & > div:nth-of-type(4) {
    border-left: none;
    justify-content: flex-end;
  }

  & > div:nth-of-type(4n + 1) {
    align-items: flex-start;
    font-weight: 700;
    border-left: none;
    text-align: left;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 48px 0.5fr;
    grid-template-rows: 1fr;

    & > div:nth-of-type(1),
    & > div:nth-of-type(2),
    & > div:nth-of-type(3),
    & > div:nth-of-type(4) {
      background: #fffbe7;
      position: sticky;
      top: 3.5rem;
      max-height: 160px;
    }

    & > div {
      border-right: 1px solid #eba920;
      border-left: none;
      border-bottom: 1px solid #f9d07c;
    }

    & > div:nth-of-type(1) {
      display: none;
    }

    & > div:nth-of-type(4n + 1) {
      grid-column: 1 / 4;
      align-items: center;
      background: #fce7bd;
      border-right: none;
      font-size: large;
      padding: 0;
    }

    & > div:nth-of-type(4n) {
      border-right: none;
    }
  }
`;
